var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useState, } from 'react';
import styled from "styled-components";
import { SdkLoader, } from "@solidgate/client-sdk-loader";
import { IFRAME_CONTAINER_ID } from '../../constants';
import useIsomorphicLayoutEffect from '../hooks/useIsomorphicLayoutEffect';
import useSdkEventSubscribers from '../hooks/useSdkEventsSubscribers';
import getPayButtonParams from "../../utils/getPayButtonParams";
import '../../boot';
const StyledPayment = styled.div `
  iframe {
    border: none;
  }
`;
const Payment = (props) => {
    const previousInitConfig = useRef();
    const [sdkInstance, setSdkInstance] = useState(null);
    const { merchantData, width, styles, formParams, applePayButtonParams, googlePayButtonParams, paypalButtonParams, googlePayContainerRef, applePayContainerRef, paypalContainerRef, onMounted = () => { }, onError = () => { }, onSuccess = () => { }, onFail = () => { }, onSubmit = () => { }, onVerify = () => { }, onCustomStylesAppended = () => { }, onPaymentDetails = () => { }, onFormRedirect = () => { }, onInteraction = () => { }, onOrderStatus = () => { }, onResize = () => { }, onReadyPaymentInstance = () => { }, onCard = () => { } } = props;
    const getInitConfig = () => {
        if (!merchantData) {
            throw new Error("Attribute 'merchantData' is required");
        }
        const config = Object.assign(Object.assign(Object.assign({ merchantData: merchantData, iframeParams: Object.assign({ containerId: IFRAME_CONTAINER_ID }, (width && { width })) }, (formParams && { formParams })), (styles && { styles })), { applePayButtonParams,
            googlePayButtonParams,
            paypalButtonParams });
        if (googlePayContainerRef === null || googlePayContainerRef === void 0 ? void 0 : googlePayContainerRef.current) {
            const googleButtonParams = getPayButtonParams(props, 'googlePayButtonParams', googlePayContainerRef.current);
            if (googleButtonParams) {
                config.googlePayButtonParams = googleButtonParams;
            }
        }
        if (applePayContainerRef === null || applePayContainerRef === void 0 ? void 0 : applePayContainerRef.current) {
            const appleButtonParams = getPayButtonParams(props, 'applePayButtonParams', applePayContainerRef.current);
            if (appleButtonParams) {
                config.applePayButtonParams = appleButtonParams;
            }
        }
        if (paypalContainerRef === null || paypalContainerRef === void 0 ? void 0 : paypalContainerRef.current) {
            const paypalButtonParams = getPayButtonParams(props, 'paypalButtonParams', paypalContainerRef.current);
            if (paypalButtonParams) {
                config.paypalButtonParams = paypalButtonParams;
            }
        }
        return config;
    };
    const subscribe = useSdkEventSubscribers({
        onMounted,
        onError,
        onSuccess,
        onFail,
        onSubmit,
        onVerify,
        onCustomStylesAppended,
        onPaymentDetails,
        onFormRedirect,
        onInteraction,
        onOrderStatus,
        onResize,
        onCard,
    }, sdkInstance);
    const initClientSdk = (config) => __awaiter(void 0, void 0, void 0, function* () {
        const clientSdk = yield SdkLoader.load();
        const clientSdkInstance = clientSdk === null || clientSdk === void 0 ? void 0 : clientSdk.init(config);
        if (!sdkInstance && clientSdkInstance) {
            subscribe(clientSdkInstance);
            setSdkInstance(clientSdkInstance);
        }
    });
    useIsomorphicLayoutEffect(() => {
        var _a;
        const config = getInitConfig();
        const key = JSON.stringify(config);
        if (((_a = previousInitConfig.current) === null || _a === void 0 ? void 0 : _a.key) !== key) {
            previousInitConfig.current = {
                config,
                key
            };
            initClientSdk(config);
        }
    });
    useEffect(() => {
        if (sdkInstance) {
            onReadyPaymentInstance(sdkInstance);
        }
    }, [sdkInstance]);
    return (_jsx(StyledPayment, { id: IFRAME_CONTAINER_ID }, void 0));
};
Payment.displayName = 'Payment';
export default Payment;
//# sourceMappingURL=Payment.js.map